<template>
  <div
    class="cart-mini-item"
    :data-cart-mini-item="item.key"
    :class="{
      'cart-mini-item_uspale': showAddToCartButton,
      loading: isItemLoading,
    }"
  >
    <div class="cart-mini-item-row">
      <div class="cart-mini-item-column cart-mini-item-column-image">
        <div
          class="badges-wrapper badges-wrapper__cart"
          v-if="
            item?.selling_plan_allocation?.compare_at_price > item?.price ||
            item?.compare_at_price > item?.price ||
            compareAt > item?.price
          "
        >
          <span class="badge">10% OFF</span>
        </div>

        <figure class="cart-mini-item-image">
          <img
            :src="item.image || item.featured_image"
            :alt="item.title"
            loading="lazy"
          />
        </figure>
      </div>

      <div class="cart-mini-item-column cart-mini-item-column-details">
        <div
          class="cart-mini-item__top"
          :class="{ 'flex-column gap-none': showAddToCartButton }"
        >
          <div>
            <span v-if="isGwpProduct" class="cart-mini-item-vendor"
              >Free Gift!</span
            >

            <span class="cart-mini-item-title">
              <a :href="item.url" v-html="item.title"> </a>
            </span>
          </div>

          <div class="cart-mini-item-prices">
            <div v-if="isGwpProduct">
              <span
                class="cart-mini-item-final-price cart-mini-item-price money strike"
              >
                {{ formatMoney(item.price) }}
              </span>
              <span class="f8 i">{{ gwpDisclaimer }}</span>
            </div>

            <template v-else>
              <span
                class="cart-mini-item-final-price cart-mini-item-price money wsgItemFinalPrice"
              >
                {{ formatMoney(item.price) }}
              </span>
            </template>
            <span
              class="cart-mini-item-prices__selling-price cart-mini-item-price money"
              v-if="
                item?.selling_plan_allocation?.compare_at_price > item?.price
              "
            >
              {{ formatMoney(item?.selling_plan_allocation?.compare_at_price) }}
            </span>
            <span
              class="cart-mini-item-prices__selling-price cart-mini-item-price money"
              v-if="compareAt > item?.price"
            >
              {{ formatMoney(compareAt) }}
            </span>
            <span
              class="cart-mini-item-prices__selling-price cart-mini-item-prices__selling-price_left cart-mini-item-price money"
              v-if="item?.compare_at_price > item?.price && showAddToCartButton"
            >
              {{ formatMoney(item.compare_at_price) }}
            </span>
          </div>
        </div>

        <div class="cart-mini-item-details-footer">
          <template v-if="!showAddToCartButton">
            <div>
              <span v-if="!isGwpProduct" class="cart-mini-item-quantity">
                <button
                  class="cart-mini-item-quantity_minus"
                  @click="update('decrement')"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="1"
                    viewBox="0 0 10 1"
                    fill="none"
                  >
                    <path d="M0 0.5H10" stroke="black" />
                  </svg>
                </button>
                <span class="pa1">{{ item.quantity }}</span>
                <button
                  class="cart-mini-item-quantity_plus"
                  @click="update('increment')"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="12"
                    viewBox="0 0 10 12"
                    fill="none"
                  >
                    <path d="M0 6.00003H10" stroke="black" />
                    <path d="M5 0L5 12" stroke="black" />
                  </svg>
                </button>
              </span>

              <ul
                v-if="itemHasDiscounts && isGwpProduct"
                class="cart-mini-item-discounts"
              >
                <li
                  v-for="(
                    discount, index
                  ) in item.line_level_discount_allocations"
                  :key="index"
                >
                  {{ discount.discount_application.title }}
                  (-<span class="money">{{ formatMoney(discount.amount) }}</span
                  >)
                </li>
              </ul>
            </div>

            <div
              class="cart-mini-item-remove"
              aria-label="remove"
              role="button"
              @click="remove"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
              >
                <line
                  x1="0.5"
                  y1="4.32108"
                  x2="14.5554"
                  y2="4.32108"
                  stroke="black"
                  stroke-linecap="round"
                />
                <path
                  d="M6.76074 0.5H8.31543C9.14365 0.500241 9.81543 1.17172 9.81543 2V4.26074H5.26074V2C5.26074 1.17157 5.93232 0.5 6.76074 0.5Z"
                  stroke="black"
                />
                <path
                  d="M2.42554 4.48648L2.87881 14.2675C2.90913 14.9219 2.92429 15.2491 3.08621 15.4844C3.16427 15.5978 3.26491 15.6939 3.38183 15.7666C3.62437 15.9174 3.9519 15.9174 4.60695 15.9174H10.3129C10.9565 15.9174 11.2782 15.9174 11.5186 15.7703C11.6345 15.6994 11.7347 15.6055 11.8132 15.4945C11.9758 15.2643 11.9969 14.9433 12.0392 14.3011L12.6855 4.48648"
                  stroke="black"
                />
              </svg>
            </div>
          </template>
          <button
            v-else-if="item.available"
            class="cart-mini-item__add"
            @click="onAddToCart"
          >
            Add
          </button>
        </div>
      </div>
    </div>

    <div
      v-if="hasSellingPlan && !showAddToCartButton"
      class="cart-mini-select-wrapper"
    >
      <select
        :value="currentSellingPlanId"
        @change="changePlan($event.target.value)"
      >
        <option v-for="plan in computedPlans" :key="plan.id" :value="plan.id">
          {{ plan.name }}
        </option>
        <option v-if="isLoadingPlans" disabled>Loading plans...</option>
      </select>
      <div class="cart-shipping-calculator-select-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="11"
          height="7"
          viewBox="0 0 11 7"
          fill="none"
        >
          <path
            d="M0.5 0.5L5.5 6.05556L10.5 0.5"
            stroke="black"
            stroke-linecap="round"
          />
        </svg>
      </div>
    </div>

    <button
      v-if="
        computedPlans.length &&
        !isGwpProduct &&
        !showAddToCartButton &&
        !hasSellingPlan
      "
      @click="changePlan(computedPlans[0].id)"
      class="cart-mini-item-add-subscribe"
      :class="{ 'is-loading': isLoadingPlans }"
    >
      + Update To Subscribe And Save 10%
    </button>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { formatMoney } from "@shopify/theme-currency";
import { imageOf, planGroupsFrom } from "../../../utils/optimistic-line";
import { isGwpLine } from "../../../utils/cart-line";

export default {
  name: "CartItem",
  props: {
    item: {
      type: Object,
      default: () => ({}),
      require: true,
    },
    showFirstSecondBox: {
      type: Boolean,
      default: false,
    },
    timezoneoffset: {
      type: Number,
      default: -7,
    },
    shipping: {
      type: Number,
      required: true,
    },
    showAddToCartButton: {
      type: Boolean,
      default: false,
    },
    gwpDisclaimer: {
      type: String,
      default: "",
    },
  },
  data: () => {
    return {
      isLoadingPlans: false,
    };
  },
  computed: {
    ...mapState("cart", {
      cart: "cartData",
      loadingItems: "loadingItems",
      productsWithDetails: "productsWithDetails",
    }),
    isItemLoading() {
      return !!this.loadingItems[this.item.key];
    },
    productDetails() {
      return this.productsWithDetails?.[this.item.id];
    },
    compareAt() {
      return Number(this.productDetails?.compare_at_price) || null;
    },
    computedPlans() {
      const product = this.productDetails;
      if (!product?.selling_plan_groups) return [];

      const plans = [];

      product.selling_plan_groups.forEach((group) => {
        group.selling_plans.forEach((plan) => {
          plans.push({
            id: plan.id,
            name: plan.name,
            recurring_deliveries: plan.recurring_deliveries,
          });
        });
      });

      return plans;
    },
    opsSubName() {
      const id = this.item?.product_id;
      if (window?.Shopify?.productOps) {
        const opsName = window?.Shopify?.productOps[id];
        return opsName;
      }
    },
    priceWhithShipping() {
      if (!this.shipping) return;
      // console.log(Number(this.shipping) + Number(this.item.price) / 100);
      return Number(this.shipping) + Number(this.item.price) / 100;
    },
    sellingPlanName() {
      return this.item?.selling_plan_allocation?.selling_plan?.name || "";
    },

    isGwpProduct() {
      return isGwpLine(this.item);
    },
    itemHasDiscounts() {
      return this.item.line_level_discount_allocations?.length > 0;
    },
    currentSellingPlanId() {
      return this.item?.selling_plan_allocation?.selling_plan?.id;
    },
    hasSellingPlan() {
      return !!this.item?.selling_plan_allocation;
    },
  },

  methods: {
    ...mapActions("cart", [
      "removeItem",
      "updateItem",
      "addItem",
      "updatePlan",
    ]),

    remove() {
      this.removeItem(this.item);
    },
    update(type) {
      this.updateItem({
        item: this.item,
        type: type,
      });
    },
    formatMoney(value) {
      return formatMoney(value, "${{amount}}");
    },
    hasVariantOrSubscription(item) {
      return item.variant_title || (item.properties && item.properties.details);
    },
    formatDiscountText({ discount_application }) {
      if (discount_application.value_type === "percentage") {
        return `${Number(discount_application.value)}%`;
      } else {
        return `$${Number(discount_application.value)}`;
      }
    },
    decodeHTML(html) {
      let textarea = document.createElement("textarea");
      textarea.innerHTML = html;
      return textarea.value;
    },

    async onAddToCart() {
      const variant = this.item?.variants?.[0];
      if (!variant?.id) return;

      // No "Adding" state and no guard: the row appears before this resolves,
      // so holding the button for the round trip only made the add look slow.
      //
      // The upsell shape from `helper-best-sellers.liquid`: its prices are
      // cents (quoted, but cents), and the variant image is the admin
      // placeholder when the variant has none of its own.
      await this.addItem({
        id: variant.id,
        quantity: 1,
        _optimistic: {
          product_title: this.item.title,
          variant_title: variant.title,
          price: Number(variant.price ?? this.item.price),
          compare_at_price:
            Number(variant.compare_at_price ?? this.item.compare_at_price) ||
            null,
          image: imageOf(this.item, variant),
          handle: this.item.handle,
          product_id: Number(this.item.id) || null,
          sku: variant.sku || this.item.sku,
          available: variant.available ?? this.item.available,
          // The row's "Update to subscribe" button is gated on the plan list,
          // which the upsell data carries.
          selling_plan_groups: planGroupsFrom(variant.sellingPlans),
        },
      });
    },

    async changePlan(planId) {
      if (!planId) return;

      if (Number(this.currentSellingPlanId) === Number(planId)) {
        return;
      }

      await this.updatePlan({
        planId: Number(planId),
        item: this.item,
      });
    },
  },
};
</script>
